/**
 * external libs
 */
import React, {createContext, useState} from 'react';

export const GlobalFolderContext = createContext({});

export function GlobalFolderProvider({children}) {
    const [folder, setFolder] = useState(null);

    return (
        <GlobalFolderContext.Provider value={{globalFolder: folder, setGlobalFolder: setFolder}}>
            {children}
        </GlobalFolderContext.Provider>
    );
}
